import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const KeyboardPortal = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 220;
  display: flex;
  justify-content: center;
  padding: 2rem;
  background-color: ${props => props.theme.color.body};
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;
`

export const KeyboardWrapper = styled.div`
  width: min(100%, 68rem);
  pointer-events: auto;
  background: ${({ theme }) => theme.color.body};
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;
`

export const KeyboardRow = styled.div<{ $offset?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 0.45rem;

  & + & {
    margin-top: 0.45rem;
  }

  ${({ $offset }) =>
    $offset &&
    css`
      padding-left: 1rem;
      padding-right: 1rem;
    `};
`

export const KeyAlternativePopup = styled.div<{ $offsetX?: number }>`
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.45rem);
  z-index: 5;
  display: flex;
  transform: translateX(calc(-50% + ${({ $offsetX = 0 }) => $offsetX}px)) translateY(var(--popup-y, 0));
  border: 1px solid currentColor;
  background: ${({ theme }) => theme.color.body};
  box-shadow: 0 0.4rem 1rem rgba(0, 0, 0, 0.1);
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;
`

export const KeyAlternativeButton = styled.span<{ $active?: boolean }>`
  width: 3.4rem;
  height: 3.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  touch-action: none;
  -webkit-touch-callout: none;
  background: 'transparent';
  color: 'inherit';

  ${props =>
    props.$active &&
    css`
      background: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.inverted};

      ${props =>
        props.theme.contrastMode &&
        css`
          background: ${props => props.theme.color.global};
          color: ${props => props.theme.color.body};
        `};
    `};

  &:not(:last-child) {
    border-right: 1px solid currentColor;
  }
`

export const KeyboardButton = styled.button<{ $wide?: boolean; $action?: boolean; $enter?: boolean }>`
  ${Reset('button')};
  position: relative;
  height: 4.5rem;
  border: 1px solid currentColor;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 0;
  padding: 0 0.75rem;
  font-size: ${({ $action }) => ($action ? '1rem' : '2rem')};
  font-weight: 500;
  line-height: 1;
  overflow: visible;
  background: ${({ theme }) => theme.color.body};
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;

  svg {
    height: 1.75rem;
    width: 2.25rem;
    fill: currentColor;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: currentColor;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  &:active::after,
  &:focus-visible::after {
    opacity: 0.05;
  }

  ${({ $wide }) =>
    $wide &&
    css`
      grid-column: span 8;
    `};

  ${({ $enter }) =>
    $enter &&
    css`
      grid-column: span 2;
    `};
`
